/*
 * Copyright 2025 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package cmp.navigation.authenticatednavbar

import androidx.compose.ui.graphics.vector.ImageVector
import cmp.navigation.generated.resources.Res
import cmp.navigation.generated.resources.home
import cmp.navigation.generated.resources.profile
import cmp.navigation.generated.resources.settings
import cmp.navigation.utils.toObjectNavigationRoute
import org.jetbrains.compose.resources.StringResource
import studio.oddpods.cauce.core.designsystem.icon.AppIcons
import studio.oddpods.cauce.core.ui.NavigationItem
import studio.oddpods.cauce.feature.dashboard.DashboardDestination
import studio.oddpods.cauce.feature.dashboard.DashboardRoute
import studio.oddpods.cauce.feature.patients.PatientsDestination
import studio.oddpods.cauce.feature.patients.PatientsListRoute
import studio.oddpods.cauce.feature.settings.SettingsRoute

sealed class AuthenticatedNavBarTabItem : NavigationItem {

    data object DashboardTab : AuthenticatedNavBarTabItem() {
        override val selectedIcon: ImageVector
            get() = AppIcons.HomeBoarder
        override val icon: ImageVector
            get() = AppIcons.Home
        override val labelRes: StringResource
            get() = Res.string.home
        override val contentDescriptionRes: StringResource
            get() = Res.string.home
        override val graphRoute: String
            get() = DashboardDestination.toObjectNavigationRoute()
        override val startDestinationRoute: String
            get() = DashboardRoute.toObjectNavigationRoute()
        override val testTag: String
            get() = "DashboardTab"
    }

    data object PatientsTab : AuthenticatedNavBarTabItem() {
        override val selectedIcon: ImageVector
            get() = AppIcons.ProfileBoarder
        override val icon: ImageVector
            get() = AppIcons.Profile
        override val labelRes: StringResource
            get() = Res.string.profile
        override val contentDescriptionRes: StringResource
            get() = Res.string.profile
        override val graphRoute: String
            get() = PatientsDestination.toObjectNavigationRoute()
        override val startDestinationRoute: String
            get() = PatientsListRoute.toObjectNavigationRoute()
        override val testTag: String
            get() = "PatientsTab"
    }

    data object SettingsTab : AuthenticatedNavBarTabItem() {
        override val selectedIcon: ImageVector
            get() = AppIcons.SettingsBoarder
        override val icon: ImageVector
            get() = AppIcons.Settings
        override val labelRes: StringResource
            get() = Res.string.settings
        override val contentDescriptionRes: StringResource
            get() = Res.string.settings
        override val graphRoute: String
            get() = SettingsRoute.toObjectNavigationRoute()
        override val startDestinationRoute: String
            get() = SettingsRoute.toObjectNavigationRoute()
        override val testTag: String
            get() = "SettingsTab"
    }
}
